module.exports = __webpack_public_path__ + "img/journal.6b61d3b3.svg";